import { createGlobalStyle } from 'styled-components';

// Solana Colors
export const SOLANA_COLORS = {
  primary: '#9945FF',
  secondary: '#14F195', 
  accent: '#00FFA3',
  bg: '#121212',
  fg: '#FFFFFF',
  error: '#FF6B6B',
  warning: '#FFD166',
  success: '#06D6A0',
};

// CSS Variables for Solana theme
export const SolanaGlobalStyles = createGlobalStyle`
  :root {
    --solana-primary: ${SOLANA_COLORS.primary};
    --solana-secondary: ${SOLANA_COLORS.secondary};
    --solana-accent: ${SOLANA_COLORS.accent};
    --solana-bg: ${SOLANA_COLORS.bg};
    --solana-fg: ${SOLANA_COLORS.fg};
    --solana-error: ${SOLANA_COLORS.error};
    --solana-warning: ${SOLANA_COLORS.warning};
    --solana-success: ${SOLANA_COLORS.success};
    --solana-gradient: linear-gradient(90deg, ${SOLANA_COLORS.primary}, ${SOLANA_COLORS.secondary});
  }
`;

export default SolanaGlobalStyles; 